import { useSelector } from "react-redux";
import { IAppState } from "../store/types";

export const useUserSelector = () =>
  useSelector((state: IAppState) => state.user);
